import { useLocation } from '@xing-com/crate-core-router';

export const useIsWebview = (): boolean => {
  const location = useLocation();

  const isWebview = /^\/pages\/webview/.test(location.pathname);

  return isWebview;
};
